import React from 'react';

function VariantSelector(props) {
    const { product, variantId, setVariantId } = props;    


    function handleChange({ target }) {
        setVariantId(target.value);
    }

    if (!product.varianten || product.varianten?.length < 2) {
        return null;
    }

    let variantList = product?.varianten.sort(orderAlphabetical);
        
    function orderAlphabetical(a, b) {
        const aStr = a.variantenBezeichnung || a.bezeichnung;
        const bStr = b.variantenBezeichnung || b.bezeichnung;
        if (aStr < bStr) return -1;
        if (aStr > bStr) return 1;
        return 0;
    }

    return (
        <>
            <div className="uk-visible@s uk-margin-remove" />
            <div>
                <form
                    className="uk-form-stacked"
                    onSubmit={e => {
                        e.preventDefault();
                    }}
                >
                    <div className="uk-margin">
                        <div className="uk-margin">
                            <label className="uk-form-label" htmlFor="variant-select" for="variant_select">
                                Variante wählen
                            </label>
                            <div className="uk-form-controls">
                                <select className="uk-select focus" name="variantId" value={variantId} onChange={handleChange} id='variant_select' aria-label={`Variante Wählen (Mit den Pfeiltasten wählbar)${(() => {
                                    const selectedVariant = variantList.find(v => v._id === variantId);
                                    if (!selectedVariant) return '';
                                    let label = (selectedVariant.variantenBezeichnung || selectedVariant.bezeichnung).replace(/<[^>]+>/gm, "");
                                    return `, Gewählt: ${label}`;
                                })()}`}
                                >
                                    {variantList.map(variant => {
                                        let label = (variant.variantenBezeichnung || variant.bezeichnung).replace(/<[^>]+>/gm, "");
                                        if (variant.aktionsPreis && variant.vk_preis && variant.aktionsPreis <= variant.vk_preis && !variant.aktionsPreisPickup) {
                                            label += ` ${variant.aktionsPreis.toFixed(2).toString().replace('.', ',').replace(/\B(?=(\d{3})+(?!\d))/g, '.')} €`;
                                        } else if (variant.aktionsPreis && variant.vk_preis && variant.aktionsPreis <= variant.vk_preis && variant.aktionsPreisPickup && variant.aktionsPreis >= variant.aktionsPreisPickup) {
                                            label += ` ${variant.aktionsPreisPickup.toFixed(2).toString().replace('.', ',').replace(/\B(?=(\d{3})+(?!\d))/g, '.')} €`;
                                        } else if (variant.aktionsPreis && variant.vk_preis && variant.aktionsPreis <= variant.vk_preis && variant.aktionsPreisPickup && variant.aktionsPreis <= variant.aktionsPreisPickup) {
                                            label += ` ${variant.aktionsPreis.toFixed(2).toString().replace('.', ',').replace(/\B(?=(\d{3})+(?!\d))/g, '.')} €`;
                                        } else if (variant.vk_preis > 0 && variant.pickup_preis && variant.vk_preis <= variant.pickup_preis) {
                                            label += ` ${variant.vk_preis.toFixed(2).toString().replace('.', ',').replace(/\B(?=(\d{3})+(?!\d))/g, '.')} €`;
                                        } else if (variant.vk_preis > 0 && variant.pickup_preis && variant.vk_preis > variant.pickup_preis) {
                                            label += ` ${variant.pickup_preis.toFixed(2).toString().replace('.', ',').replace(/\B(?=(\d{3})+(?!\d))/g, '.')} €`;
                                        } else if (variant.vk_preis > 0) {
                                            label += ` ${variant.vk_preis.toFixed(2).toString().replace('.', ',').replace(/\B(?=(\d{3})+(?!\d))/g, '.')} €`;
                                        }
                                        return (
                                            <option value={variant._id} key={variant._id}>
                                               {label} 
                                            </option>
                                        );
                                    })}
                                </select>
                            </div>
                        </div>
                    </div>
                </form>
            </div>
        </>
    );
}

export default VariantSelector;
